module.exports = __webpack_public_path__ + "static/img/player_head_12.d6da079.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/user/player_head_12.jpg
// module id = fF4b
// module chunks = 1